import React from 'react';
import lealRoleChatIcon from 'assets/icons/leal_role_chat.png';
import './chatLoader.css';

export const ChatLoader = () => (
  <div className="chat-loader-container">
    <div className="chat-loader-avatar">
      <img src={lealRoleChatIcon} alt="AI Assistant" />
    </div>
    <div className="chat-loader-content">
      <div className="typing-indicator">
        <span />
        <span />
        <span />
      </div>
      <div className="processing-text">
        AI Oncology Expert processing your information
      </div>
    </div>
  </div>
);
